import React, { useEffect, useState } from 'react';
import './Measurement.css';
import MeasurementLeftMenuBar from './MeasurementLeftMenuBar';
import IvMeasurementInverterInfo from './IvMeasurementInverterInfo';
import IvMeasurementInfo from './IvMeasurementInfo';
import IvMeasurementStatusInfo from './IvMeasurementStatusInfo';
import IvMeasurementLineChart from './IvMeasurementLineChart';
import BniMeasurementInfo from './BniMeasurementInfo';
import DwMeasurementInfo from './DwMeasurementInfo';
import JbMrtMeasurementInfo from './JbMrtMeasurementInfo';
import JbG2PowerSet from './JbG2PowerSet';
import EnineMeasurementInfo from './EnineMeasurementInfo';
import BnmMeasurementInfo from './BnmMeasurementInfo';
import useIsRemsIv from '../../hooks/useIsRemsIv';
import ToggleButton from '../../components/ToggleButton';
import IvMpptstate from './IvMpptstate';
import Uwhan2MeasurementInfo from './Uwhan2MeasurementInfo';
import useIsMobile from '../../hooks/useIsMobile';
import EvMeasurementLineChart from './EvMeasurementLineChart'
import '../../App.css';
import JbMeasurementTotalList from '../measurement/SideBarMeasurement/JbMeasurementTotalList'
import IvMeasurementTotalList from '../measurement/SideBarMeasurement/IvMeasurementTotalList'
import InvAc from './InvAc';
import SmartPowerMeasurementInfo from './SmartPowerMeasurementInfo';
import GaramMeasurementInfo from './GaramMeasurementInfo';
import HanbitMeasurementInfo from './HanbitMeasurementInfo';
import useIsDik from '../../hooks/useIsDik';
import useIsDas_tech from '../../hooks/useIsDas_tech';
import useIsHex_3 from '../../hooks/useIsHex_3';
import useIsG2powerIv from '../../hooks/useIsG2powerIv';
import useIsTeldaIv from '../../hooks/useIsTeldaIv';
import useIsUnitestInv from '../../hooks/useIsUnitestInv';
import useIsDongeiInv from '../../hooks/useIsDongeiInv';
import useIsSpaceone from '../../hooks/useIsSpaceone';
import useIsWillingsInv from '../../hooks/useIsWillingsInv';
import useIsGoodwe60kIv from '../../hooks/useIsGoodwe60kIv';
import { fetchIv_list, fetchJb_list, fetchSettings } from '../../store';
import { useDispatch, useSelector } from 'react-redux';



function Measurement() {
  const Jb_list = useSelector((state) => state.Jb_list || {});
  const [index, Setindex] = useState(null); // index를 초기값 null로 설정
  const [isGraph, setisGraph] = useState(true);
  const isMobile = useIsMobile();




  const dispatch = useDispatch();
  const StateSelDeviceIv = useSelector((state) => state.StateSelDeviceIv || null);  // null로 명확하게 처리
  const StateSelDeviceJb = useSelector((state) => state.StateSelDeviceJb || null);  // null로 명확하게 처리
  const StateSelDeviceEv = useSelector((state) => state.StateSelDeviceEv || null);  // null로 명확하게 처리
  
  //장비가 rems인지 아닌지 구분하기 위한 coustomhook사용 
  const SelInverter = useSelector((state) => state.StateSelDeviceIv || null);
  const isRems = useIsRemsIv(SelInverter);
  const isDik = useIsDik(SelInverter);
  const isDas_tech = useIsDas_tech(SelInverter);
  const ishex_3 = useIsHex_3(SelInverter);
  const isG2power = useIsG2powerIv(SelInverter);
  const isTelda = useIsTeldaIv(SelInverter);
  const isUnitest = useIsUnitestInv(SelInverter);
  const isDongei = useIsDongeiInv(SelInverter);
  const isSpaceone = useIsSpaceone(SelInverter);
  const isWillings = useIsWillingsInv(SelInverter);
  const isGoodwe60k = useIsGoodwe60kIv(SelInverter);
  useEffect(() => {
    if (Jb_list.seq && Array.isArray(Jb_list.seq)) {
      Jb_list.seq.forEach((seq, key) => {
        if (StateSelDeviceJb === seq) {
          Setindex(key);
        }
      });
    } else {
      // console.log('Jb_list.seq is not an array or undefined'); // 디버그용
    }
  }, [Jb_list, StateSelDeviceJb]);


  // 최초 장비 리스트 불러오기
  useEffect(() => {
    dispatch(fetchIv_list());
    dispatch(fetchJb_list());
  }, [dispatch]);

  useEffect(() => {
    if (isRems && !isGraph) {
      setisGraph(true); // MPPT 상태일 경우, 강제로 그래프로 되돌림
    }
  }, [isRems, isGraph]);

  useEffect(() => {
    if (isGoodwe60k && !isGraph) {
      setisGraph(true);
    }
  }, [isGoodwe60k, isGraph]);

  return (
    <div className="main-Public-wrap">

      <div className="Measurement-wrap">
        {/* 좌측메뉴바 */}
        <div className="sidebar-container">
          <MeasurementLeftMenuBar />
        </div>

        {/* 조건부 렌더링 */}
        {StateSelDeviceIv === 'TotalList' ? (
          // 🔹 인버터 전체보기일 때
          <div style={{ width: '100%' }}>
            <IvMeasurementTotalList />
            <InvAc />
          </div>

        ) : StateSelDeviceIv !== null ? (
          // StateSelDeviceIv가 있을 때 인버터 정보 렌더링
          <div style={{ width: '100%' }}>
            <div className="InverterInfo-container">
              <div style={{ width: '100%' }}>
                <IvMeasurementInverterInfo SelInverter={StateSelDeviceIv} />
              </div>
              <div className="MeasurementRight-wrap">
                <div>
                  <IvMeasurementInfo SelInverter={StateSelDeviceIv} />
                </div>
                <div>
                  <IvMeasurementStatusInfo SelInverter={StateSelDeviceIv} />
                </div>
              </div>
            </div>
            <div className="MeasurementLineChart" style={{ position: 'relative' }}>
              {/* 우측 상단 토글 버튼 */}
              {!isRems && !isDas_tech && !isDik && !ishex_3 && !isG2power && !isTelda && !isUnitest && !isDongei && !isSpaceone && !isWillings && !isGoodwe60k && (
                <div className="toggle-fixed">
                  <ToggleButton isOn={isGraph} onToggle={() => setisGraph(!isGraph)} />
                </div>
              )}

              {/* 상단 박스는 MPPT일 때만 렌더링 */}
              {!isGraph && (
                <div className='inverterGenInfo-TopBox'>
                  <div style={{ color: '#6B7476', fontSize: isMobile ? '17px' : '20px', fontWeight: '600', paddingLeft: '20px' }}>
                    ◎ MPPT 정보
                  </div>
                  <div style={{ flexGrow: '1' }}></div>
                  <div style={{ color: '#6B7476', fontSize: isMobile ? '17px' : '20px', fontWeight: '600', padding: '0px 20px' }}>
                    ⦁ ⦁ ⦁
                  </div>
                </div>
              )}

              {/* 콘텐츠 */}
              {isGraph ? (
                <IvMeasurementLineChart SelInverter={StateSelDeviceIv} />
              ) : (
                <IvMpptstate SelInverter={StateSelDeviceIv} />
              )}
            </div>
          </div>
        ) : StateSelDeviceJb !== null ? (
          // StateSelDeviceJb가 있을 때 접속함 정보 렌더링

          // StateSelDeviceIv가 있을 때 인버터 정보 렌더링
          <div style={{ width: '100%' }}>
            <div className="InverterInfo-container">
              <div style={{ width: '100%' }}>


                {StateSelDeviceJb === 'TotalList' ? (
                  /* 계측장비-접속함-전체보기 */
                   // 전체보기 선택 시 접속함 목록을 표시하는 컴포넌트
                  /* style = {{ marginTop: '10px', width: '1580px', borderRadius: '10px' }} */
                  <div>
                    <JbMeasurementTotalList />
                  </div>


                ) : (

                  <>
                    {/* 선택된 접속함의 프로토콜에 따라 적절한 컴포넌트 렌더링 */}
                    {Jb_list.jb_protocol[index] === '비앤아이테크' ? (
                      <BniMeasurementInfo SelJb={StateSelDeviceJb} />
                    ) : Jb_list.jb_protocol[index] === '엠알티-표준' ? (
                      // 페어로 지투파워가 묶여 있으면 G2 전용 UI로 표시 (SelJb는 지투파워 seq로 전달)
                      (Jb_list.pair_device && Jb_list.pair_device[index] &&
                       Jb_list.jb_protocol[
                         (Jb_list.seq || []).findIndex((s) => s === Jb_list.pair_device[index])
                       ] === '지투파워') ? (
                        <JbG2PowerSet SelJb={Jb_list.pair_device[index]} />
                      ) : (
                        <JbMrtMeasurementInfo SelJb={StateSelDeviceJb} />
                      )
                    ) : Jb_list.jb_protocol[index] === '비엔엠' ? (
                      <BnmMeasurementInfo SelJb={StateSelDeviceJb} />
                    ) : Jb_list.jb_protocol[index] === '대원전기' ? (
                      <DwMeasurementInfo SelJb={StateSelDeviceJb} />
                    ) : Jb_list.jb_protocol[index] === '이나인파워' ? (
                      <EnineMeasurementInfo SelJb={StateSelDeviceJb} />
                    ) : Jb_list.jb_protocol[index] === '유환마이크로' ? (
                      <Uwhan2MeasurementInfo SelJb={StateSelDeviceJb} />
                    ) : Jb_list.jb_protocol[index] === '스마트파워-optimizer' ? (
                      <SmartPowerMeasurementInfo SelJb={StateSelDeviceJb} />
                    ) : Jb_list.jb_protocol[index] === '지투파워' ? (
                      // 지투파워 자체 선택 → G2 UI 사용
                      <JbG2PowerSet SelJb={StateSelDeviceJb} />
                    ) : (Jb_list.jb_protocol[index] === '가람' || Jb_list.jb_protocol[index] === '동천기공') ? (
                      <GaramMeasurementInfo SelJb={StateSelDeviceJb} />
                    ) : Jb_list.jb_protocol[index] === '한빛' ? (
                      <HanbitMeasurementInfo SelJb={StateSelDeviceJb} />
                    ): (
                      <div>지원되지 않는 프로토콜입니다.</div>
                    )}
                  </>

                )}

              </div>
            </div>

          </div>

        ) : StateSelDeviceEv !== null ? (
          /* 계측장비-환경센서 */
          // EV 충전 장비(StateSelDeviceEv)가 선택된 경우 EV 정보 렌더링
          <div style={{ width: '100%' }}>
            <div className="InverterInfo-container">
              <div style={{ width: '100%', marginTop: '10px' }}>
                {/* <MainEnSensor TopTitle={'환경 센서'}/> */}
                {/* EV 충전 데이터 그래프 표시 */}
                <EvMeasurementLineChart />
              </div>
            </div>

          </div>

        ) : (
          // 아무 장비도 선택되지 않은 경우 기본 화면 표시
          <div style={{ width: '100%', textAlign: 'center', padding: '50px' }}>
            <h2>장비를 선택하세요</h2>
          </div>
        )}
      </div>
    </div>
  );
}


export default Measurement;







